import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3v18h18","key":"svg-0"}],["path",{"d":"M8 15.015v.015","key":"svg-1"}],["path",{"d":"M16 16.015v.015","key":"svg-2"}],["path",{"d":"M8 7.03v.015","key":"svg-3"}],["path",{"d":"M12 11.03v.015","key":"svg-4"}],["path",{"d":"M19 11.03v.015","key":"svg-5"}]]

const IconChartScatter = createReactComponent('outline', 'chart-scatter', 'ChartScatter', __iconNode);

export default IconChartScatter;